import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsApplicationAreas(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_APPLICATION_AREA,
		ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREAS,
		options
	)
}

function _createRegulationsApplicationArea(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_APPLICATION_AREA,
		ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].CREATE_REGULATIONS_APPLICATION_AREA,
		options
	)
}

function _getRegulationsApplicationArea(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_APPLICATION_AREA,
		ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREA,
		options
	)
}

function _patchRegulationsApplicationArea(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_APPLICATION_AREA,
		ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PATCH_REGULATIONS_APPLICATION_AREA,
		options
	)
}

function _putRegulationsApplicationArea(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_APPLICATION_AREA,
		ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PUT_REGULATIONS_APPLICATION_AREA,
		options
	)
}

function _deleteRegulationsApplicationArea(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_APPLICATION_AREA,
		ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].DELETE_REGULATIONS_APPLICATION_AREA,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREA]: _getRegulationsApplicationAreas,

	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].CREATE_REGULATIONS_APPLICATION_AREA]: _createRegulationsApplicationArea,
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREA]: _getRegulationsApplicationArea,
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PATCH_REGULATIONS_APPLICATION_AREA]: _patchRegulationsApplicationArea,
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PUT_REGULATIONS_APPLICATION_AREA]: _putRegulationsApplicationArea,
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].DELETE_REGULATIONS_APPLICATION_AREA]: _deleteRegulationsApplicationArea,
}